var map = {
	"./brl.png": "e0ee",
	"./da.png": "ffa1",
	"./de.png": "72fe",
	"./el.png": "de9b",
	"./en.png": "9996",
	"./es.png": "20ca",
	"./fr.png": "26fc",
	"./gbp.png": "af74",
	"./hu.png": "5753",
	"./idr.png": "d4ec",
	"./inr.png": "5544",
	"./it.png": "7ba1",
	"./ja.png": "c66c",
	"./jp.png": "f512",
	"./pl.png": "6306",
	"./pt.png": "5e3c",
	"./ru.png": "0b39",
	"./sv.png": "be51",
	"./tr.png": "12dd",
	"./zh.png": "12ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c99";